module.exports = __webpack_public_path__ + "static/media/item_8_10_comp.75e4b5e9.png";